import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"

export const NombreCuentaContable = ({
  cuentaContableLabel = "-",
  cuentaContableId = "",
}) => {
  const history = useHistory()

  const handleRedirectToDetail = (id: string) => {
    history.push(`${ROUTES.LIBRO_MAYOR}/${id}`)
  }
  return (
    <p
      onClick={() => {
        !window.location?.pathname?.includes("/contabilidad/libro-mayor") &&
          handleRedirectToDetail(cuentaContableId)
      }}
      className='hover:tw-underline tw-text-sm tw-m-0 tw-text-info'
    >
      {cuentaContableLabel}
    </p>
  )
}
